"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShockwavePlugin = exports.ShockwavePipeline = void 0;
var shockwaveShader = "precision mediump float;\n\nvarying vec2 outTexCoord;\nuniform sampler2D uMainSampler;\nuniform vec4 filterArea;\n\nuniform vec2 center;\n\nuniform float amplitude;\nuniform float wavelength;\nuniform float brightness;\nuniform float speed;\nuniform float radius;\n\nuniform float time;\n\nconst float PI = 3.14159;\n\nvoid main()\n{\n    float halfWavelength = wavelength * 0.5 / filterArea.x;\n    float maxRadius = radius / filterArea.x;\n    float currentRadius = time * speed / filterArea.x;\n\n    float fade = 1.0;\n\n    if (maxRadius > 0.0) {\n        if (currentRadius > maxRadius) {\n            gl_FragColor = texture2D(uMainSampler, outTexCoord);\n            return;\n        }\n        fade = 1.0 - pow(currentRadius / maxRadius, 2.0);\n    }\n\n    vec2 dir = vec2(outTexCoord - center / filterArea.xy);\n    dir.y *= filterArea.y / filterArea.x;\n    float dist = length(dir);\n\n    if (dist <= 0.0 || dist < currentRadius - halfWavelength || dist > currentRadius + halfWavelength) {\n        gl_FragColor = texture2D(uMainSampler, outTexCoord);\n\n        return;\n    }\n\n    vec2 diffUV = normalize(dir);\n\n    float diff = (dist - currentRadius) / halfWavelength;\n\n    float p = 1.0 - pow(abs(diff), 2.0);\n\n    float powDiff = 1.25 * sin(diff * PI) * p * ( amplitude * fade );\n\n    vec2 offset = diffUV * powDiff / filterArea.xy;\n    vec4 color = texture2D(uMainSampler, outTexCoord + offset);\n    color.rgb *= 1.0 + (brightness - 1.0) * p * fade;\n\n    gl_FragColor = color;\n}";
var ShockwavePipeline = /** @class */ (function (_super) {
    __extends(ShockwavePipeline, _super);
    function ShockwavePipeline(game) {
        return _super.call(this, { game: game, renderer: game.renderer, fragShader: shockwaveShader }) || this;
    }
    return ShockwavePipeline;
}(Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline));
exports.ShockwavePipeline = ShockwavePipeline;
function getTintFromFloats(r, g, b, a) {
    var ur = ((r * 255.0) | 0) & 0xFF;
    var ug = ((g * 255.0) | 0) & 0xFF;
    var ub = ((b * 255.0) | 0) & 0xFF;
    var ua = ((a * 255.0) | 0) & 0xFF;
    return ((ua << 24) | (ur << 16) | (ug << 8) | ub) >>> 0;
}
function getTintAppendFloatAlpha(rgb, a) {
    var ua = ((a * 255.0) | 0) & 0xFF;
    return ((ua << 24) | rgb) >>> 0;
}
var ShockwavePlugin = /** @class */ (function (_super) {
    __extends(ShockwavePlugin, _super);
    function ShockwavePlugin(scene, pluginManager) {
        var _this = _super.call(this, scene, pluginManager) || this;
        _this.shockwaves = [];
        return _this;
    }
    ShockwavePlugin.onBoot = function (game) {
        if (ShockwavePlugin.textureA == null) {
            var renderer = game.renderer, _a = game.renderer, width = _a.width, height = _a.height;
            ShockwavePlugin.textureA = renderer.createTextureFromSource(null, width, height, 0);
            ShockwavePlugin.textureB = renderer.createTextureFromSource(null, width, height, 0);
            ShockwavePlugin.framebufferA = renderer.createFramebuffer(width, height, ShockwavePlugin.textureA, false);
            ShockwavePlugin.framebufferB = renderer.createFramebuffer(width, height, ShockwavePlugin.textureB, false);
            if (renderer.pipelines.ShockwavePipeline == null) {
                renderer.addPipeline("ShockwavePipeline", new ShockwavePipeline(game));
            }
        }
    };
    ShockwavePlugin.prototype.add = function (x, y, options) {
        if (options === void 0) { options = {}; }
        var shockwave = Object.assign({
            amplitude: 30,
            wavelength: 160,
            brightness: 1,
            speed: 500,
            radius: -1
        }, options, { x: x, y: y, time: 0 });
        this.shockwaves.push(shockwave);
    };
    ShockwavePlugin.prototype.remove = function () {
        this.shockwaves = [];
    };
    ShockwavePlugin.prototype.boot = function () {
        ShockwavePlugin.onBoot(this.game);
        this.nextFramebuffer = ShockwavePlugin.framebufferA;
        // @ts-ignore
        this.systems.cameras.render = this.render.bind(this);
        this.systems.events.on("update", this.update, this);
    };
    ShockwavePlugin.prototype.update = function (time, delta) {
        var shockwaves = this.shockwaves;
        for (var index = shockwaves.length - 1; index >= 0; index -= 1) {
            var shockwave = shockwaves[index];
            shockwave.time += delta / 1000;
            if (shockwave.time > ShockwavePlugin.MAX_AGE) {
                shockwaves.splice(index, 1);
            }
        }
    };
    ShockwavePlugin.prototype.render = function (renderer, children, interpolation) {
        var _a = this.systems.cameras, scene = _a.scene, cameras = _a.cameras;
        for (var index = 0; index < cameras.length; index += 1) {
            var camera = cameras[index];
            if (camera.visible && camera.alpha > 0) {
                // @ts-ignore
                camera.preRender(1);
                if (this.shockwaves.length > 0 && !camera.renderToTexture) {
                    this.renderCamera(renderer, scene, children, interpolation, camera);
                }
                else {
                    renderer.render(scene, children, interpolation, camera);
                }
            }
        }
    };
    ShockwavePlugin.prototype.renderCamera = function (renderer, scene, children, interpolation, camera) {
        if (renderer.contextLost) {
            return;
        }
        Object.values(renderer.pipelines).forEach(function (pipeline) {
            // @ts-ignore
            pipeline.onRender(scene, camera);
        });
        var cx = camera._cx;
        var cy = camera._cy;
        var cw = camera._cw;
        var ch = camera._ch;
        this.nextFramebuffer = ShockwavePlugin.framebufferA;
        this.bindNextFramebuffer(renderer);
        var textureTint = renderer.pipelines.TextureTintPipeline;
        var color = camera.backgroundColor;
        renderer.pushScissor(cx, cy, cw, ch);
        if (camera.mask != null) {
            renderer.currentCameraMask.mask = camera.mask;
            renderer.currentCameraMask.camera = camera._maskCamera;
            camera.mask.preRenderWebGL(renderer, camera, camera._maskCamera);
        }
        if (color.alphaGL > 0) {
            textureTint.drawFillRect(cx, cy, cw, ch, getTintFromFloats(color.redGL, color.greenGL, color.blueGL, 1), color.alphaGL);
        }
        var list = children.list;
        var childCount = list.length;
        renderer.currentType = "";
        var current = renderer.currentMask;
        for (var index = 0; index < childCount; index += 1) {
            var child = list[index];
            if (!child.willRender(camera)) {
                continue;
            }
            if (child.blendMode !== renderer.currentBlendMode) {
                renderer.setBlendMode(child.blendMode);
            }
            var mask = child.mask;
            current = renderer.currentMask;
            if (current.mask != null && current.mask !== mask) {
                current.mask.postRenderWebGL(renderer, current.camera);
            }
            if (mask != null && current.mask !== mask) {
                mask.preRenderWebGL(renderer, child, camera);
            }
            var type = child.type;
            if (type !== renderer.currentType) {
                renderer.newType = true;
                renderer.currentType = type;
            }
            renderer.nextTypeMatch = (index < childCount - 1)
                ? (list[index + 1].type === renderer.currentType)
                : false;
            child.renderWebGL(renderer, child, interpolation, camera);
            renderer.newType = false;
        }
        current = renderer.currentMask;
        if (current.mask != null) {
            current.mask.postRenderWebGL(renderer, current.camera);
        }
        renderer.setBlendMode(Phaser.BlendModes.NORMAL);
        renderer.postRenderCamera(camera);
        var shockwaves = this.shockwaves;
        var shockwaveCount = shockwaves.length;
        var pipeline = renderer.pipelines.ShockwavePipeline;
        for (var index = 0; index < shockwaveCount; index += 1) {
            var shockwave = shockwaves[index];
            var lastFramebuffer = renderer.currentFramebuffer;
            if (index === shockwaveCount - 1) {
                renderer.flush();
                renderer.setFramebuffer(null);
            }
            else {
                this.bindNextFramebuffer(renderer);
            }
            renderer.setPipeline(pipeline, camera);
            pipeline.setFloat4("filterArea", cw, ch, cx, cy);
            pipeline.setFloat2("center", shockwave.x, ch - shockwave.y);
            pipeline.setFloat1("amplitude", shockwave.amplitude);
            pipeline.setFloat1("wavelength", shockwave.wavelength);
            pipeline.setFloat1("brightness", shockwave.brightness);
            pipeline.setFloat1("speed", shockwave.speed);
            pipeline.setFloat1("radius", shockwave.radius);
            pipeline.setFloat1("time", shockwave.time);
            var renderTexture = lastFramebuffer.renderTexture;
            var width = renderTexture.width, height = renderTexture.height;
            pipeline.projOrtho(0, width, height, 0, -1000, 1000);
            pipeline.setTexture2D(renderTexture, 0);
            pipeline.batchQuad(cx, cy + ch, cx, cy, cx + cw, cy, cx + cw, cy + ch, cx / width, (height - cy - ch) / height, (cx + cw) / width, (height - cy) / height, getTintAppendFloatAlpha(camera._tintTL, camera._alphaTL), getTintAppendFloatAlpha(camera._tintTR, camera._alphaTR), getTintAppendFloatAlpha(camera._tintBL, camera._alphaBL), getTintAppendFloatAlpha(camera._tintBR, camera._alphaBR), (camera._isTinted && camera.tintFill), renderTexture, 0);
        }
        renderer.setBlankTexture(true);
    };
    ShockwavePlugin.prototype.bindNextFramebuffer = function (renderer) {
        var nextFramebuffer = this.nextFramebuffer;
        var gl = renderer.gl;
        renderer.flush();
        renderer.setFramebuffer(nextFramebuffer);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        this.nextFramebuffer = (nextFramebuffer === ShockwavePlugin.framebufferA)
            ? ShockwavePlugin.framebufferB
            : ShockwavePlugin.framebufferA;
    };
    ShockwavePlugin.prototype.destroy = function () {
        // @ts-ignore
        if (this.systems.cameraManager != null) {
            // @ts-ignore
            this.systems.cameraManager.render = Phaser.Cameras.Scene2D.CameraManager.prototype.render;
        }
        this.systems.events.off("update", this.update, this);
        _super.prototype.destroy.call(this);
    };
    ShockwavePlugin.MAX_AGE = 3;
    return ShockwavePlugin;
}(Phaser.Plugins.ScenePlugin));
exports.ShockwavePlugin = ShockwavePlugin;
